import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import InputAdornment from '@mui/material/InputAdornment';
import { useState, useEffect, useContext } from 'react';
import {
    TextField,
    Grid2,
} from "@mui/material";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { GlobalStyles } from '@mui/material';
import './Login.css';
import lightLogo from '../../../Images/fouchain-logo-light.svg';
import darkLogo from "../../../Images/fouchain-logo-dark.svg";
import { ThemeContext } from '../../DarkMode/ThemeProvider';
import { useLocation, useNavigate } from 'react-router-dom';
import { ResetPassword } from '../../../Services/auth';
import { ToastError, ToastSuccess } from '../../../CustomToaster/CustomToaster';
import { InputError } from '../../Errors/ErrorText';

const Reset = () => {


    const [showPassword, setShowPassword] = React.useState(false);

    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const handleMouseUpPassword = (event) => {
        event.preventDefault();
    };
    const { isLightMode } = useContext(ThemeContext);

    //custom code
    const navigate = useNavigate();
    const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);

    const handleClickShowConfirmPassword = () =>
        setShowConfirmPassword((show) => !show);

    const location = useLocation();
    const [errors, setErrors] = useState({
        password: "",
        confirmpassword: "",
    });
    const [allPassword, setAllPassword] = useState({
        password: "",
        confirmpassword: "",
    });
    const [token, setToken] = useState(null);

    // Get email from location.state (passed via navigate)
    const emailFromState = location.state?.email || "";

    // Keep email in state if you want, or just use emailFromState directly
    const [email, setEmail] = useState(emailFromState);
    const [load, setLoad] = useState(false);

    const [strength, setStrength] = useState(0);

    useEffect(() => {
        if (!location?.state?.verify) {
            navigate("/forget");
        }
        if (location?.state?.token) {
            setToken(location?.state?.token);
        }
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        const fieldValue = value.trim();


        // Limit length to 30
        if (fieldValue.length > 30) return;

        // Update the state first
        setAllPassword((prev) => ({ ...prev, [name]: value }));

        let newErrors = { ...errors };

        // Live validation
        if (name === "password") {
            if (!fieldValue) {
                newErrors.password = "Password is required";
            } else if (fieldValue.length < 8) {
                newErrors.password = "Password must be at least 8 characters long";
            } else if (!/[a-z]/.test(fieldValue)) {
                newErrors.password = "Password must contain at least one lowercase letter";
            } else if (!/[A-Z]/.test(fieldValue)) {
                newErrors.password = "Password must contain at least one uppercase letter";
            } else if (!/\d/.test(fieldValue)) {
                newErrors.password = "Password must contain at least one number";
            } else if (!/[!@#$%^&*(),.?":{}|<>]/.test(fieldValue)) {
                newErrors.password = "Password must contain at least one special character";
            } else {
                newErrors.password = "";
            }

            // Revalidate confirmPassword if it has value
            if (allPassword.confirmpassword && allPassword.confirmpassword !== fieldValue) {
                newErrors.confirmpassword = "Confirm password does not match";
            } else {
                newErrors.confirmpassword = "";
            }
        }

        if (name === "confirmpassword") {
            if (!fieldValue) {
                newErrors.confirmpassword = "Confirm password is required";
            } else if (fieldValue.length < 8) {
                newErrors.confirmpassword = "Confirm Password must be at least 8 characters long";
            } else if (fieldValue !== allPassword.password) {
                newErrors.confirmpassword = "Confirm password does not match";
            } else {
                newErrors.confirmpassword = "";
            }
        }

        setErrors(newErrors);
    };



    const validateFocus = (e) => {
        const fieldName = e?.target?.name;
        const fieldValue = e?.target?.value;
        const value = fieldValue.trim();

        let isValid = true;
        let errorMessage = "";

        if (fieldName === "password") {
            if (value === "" || value === undefined) {
                errorMessage = "Password is required";
                isValid = false;
            }
        } else {
            if (value === "" || value === undefined) {
                errorMessage = "Confirm Password is required";
                isValid = false;
            } else if (
                value !== allPassword.password &&
                allPassword.password !== ""
            ) {
                errorMessage = "Confirm Password does not match";
                isValid = false;
            }
        }

        setErrors((prevErrors) => ({
            ...prevErrors,
            [fieldName]: errorMessage,
        }));

        return isValid;
    };

    const validate = () => {
        let formErrors = {};
        let isValid = true;
        if (!allPassword.password) {
            formErrors.password = "Password is required";
            isValid = false;
        } else if (allPassword.password.length < 8) {
            formErrors.password = "Password must be at least 8 characters long";
            isValid = false;
        } else if (!/[a-z]/.test(allPassword?.password) && !/[A-Z]/.test(allPassword?.password)) {
            formErrors.password = "Password must be one uppercase and one lowercase letter";
            isValid = false;
        } else if (!/\d/.test(allPassword?.password) || !/[!@#$%^&*(),.?":{}|<>]/.test(allPassword?.password)) {
            formErrors.password = "Password must be with one number and one special character";
            isValid = false;
        }

        if (!allPassword.confirmpassword) {
            formErrors.confirmpassword = "Confirm password is required";
            isValid = false;
        } else if (allPassword.confirmpassword.length < 8) {
            formErrors.confirmpassword = "Confirm Password must be at least 8 characters long";
            isValid = false;
        } else if (allPassword.password != allPassword.confirmpassword) {
            formErrors.confirmpassword = "Confirm password does not match";
            isValid = false;
        };
        setErrors(formErrors);
        return isValid;
    };

    const handleResetSubmit = async (e) => {
        e.preventDefault();
        if (validate()) {
            setLoad(true);
            const data = {
                newPassword: allPassword.password,
                confirmPassword: allPassword.confirmpassword,
                email: email,
            };

            const response = await ResetPassword(data);

            if (response?.data?.success === true) {
                ToastSuccess({ message: response?.data?.message, icon: false });

                setLoad(false);
                setTimeout(() => {
                    navigate("/login", { replace: true });
                }, 1000);
            } else {
                ToastError({ message: response?.data?.message, icon: false });

                setLoad(false);
            }
        }
    };

    return (
        <div className='auth-page login-page '>

            {/* <ThemeProvider theme={theme}>
                <CssBaseline /> */}
            <GlobalStyles
                styles={{
                    ':root': {
                        '--Form-maxWidth': '800px',
                        '--Transition-duration': '0.4s',
                    },
                }}
            />
            <Box
                component="main"
                className='login-card'
            >
                <Box sx={{ gap: 2, display: 'flex', alignItems: 'center', justifyContent: "center" }}>
                    <a href="/">     <img src={!isLightMode ? lightLogo : darkLogo} alt='logo' width={150} /></a>
                </Box>
                <Stack sx={{ gap: 4, mb: 2 }}>
                    <Stack sx={{ gap: 1 }}>
                        <Typography component="h1" sx={{ fontSize: '25px', textAlign: 'center' }}>
                            Reset Password
                        </Typography>
                    </Stack>
                </Stack>
                <Grid2 container spacing={2}>
                    <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                        <FormControl fullWidth required>
                            <div className='input-common'>
                                <FormLabel>New Password</FormLabel>
                                <TextField
                                    name="password"
                                    type={showPassword ? "text" : "password"}
                                    fullWidth
                                    placeholder="Enter your password"
                                    value={allPassword.password}
                                    onChange={handleChange}
                                    onInput={validateFocus}
                                    error={!!errors.password}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label={showPassword ? "hide password" : "show password"}
                                                    onClick={handleClickShowPassword}
                                                    onMouseDown={handleMouseDownPassword}
                                                    onMouseUp={handleMouseUpPassword}
                                                    edge="end"
                                                >
                                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                                </IconButton>
                                            </InputAdornment>
                                        )
                                    }}
                                />
                                <InputError error={errors.password} />
                            </div>
                        </FormControl>
                    </Grid2>
                    <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                        <FormControl fullWidth required>
                            <div className='input-common'>
                                <FormLabel>Confirm Password</FormLabel>
                                <TextField
                                    name="confirmpassword"
                                    type={showConfirmPassword ? "text" : "password"}
                                    fullWidth
                                    placeholder="Enter your confirm password"
                                    value={allPassword.confirmpassword}
                                    onChange={handleChange}
                                    onInput={validateFocus}
                                    error={!!errors.confirmpassword}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label={showConfirmPassword ? "hide password" : "show password"}
                                                    onClick={handleClickShowConfirmPassword}
                                                    onMouseDown={handleMouseDownPassword}
                                                    onMouseUp={handleMouseUpPassword}
                                                    edge="end"
                                                >
                                                    {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                                                </IconButton>
                                            </InputAdornment>
                                        )
                                    }}
                                />
                                <InputError error={errors.confirmpassword} />
                            </div>
                        </FormControl>
                    </Grid2>
                    <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                        <Stack spacing={2} mt={2}>
                            <div className='but-one text-center'>
                                {
                                    load === true ?
                                        <Button type="submit" variant="contained" fullWidth
                                            disabled
                                        >
                                            Progressing
                                        </Button>
                                        :
                                        <Button type="submit" variant="contained" fullWidth
                                            onClick={(e) => {
                                                handleResetSubmit(e);
                                            }}
                                        >
                                            Continue
                                        </Button>
                                }
                            </div>
                        </Stack>
                    </Grid2>
                </Grid2>
                {/* </form> */}

            </Box>

        </div>
    )
}

export default Reset
